/*
  Sections to track require data-name attribute
  content can be tracked with the help of data-title attribute
*/
export const sendEvent = (eventName = '', eventData = {}) => {
  if (!eventName || !eventData || typeof eventData !== 'object') {
    return;
  }
  Shopify.analytics.publish(eventName, eventData);
  window.dataLayer?.push({
    event: eventName,
    ...Object.fromEntries(
      Object.entries(eventData).map((item) => [
        item[0].replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`),
        item[1],
      ]),
    ),
  });
};

const Tracking = () => {
  const mainContent = document.querySelector('#MainContent');
  const sections = mainContent.querySelectorAll('.shopify-section');

  const trackItemView = () => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    function callbackFunction(entries) {
      entries.forEach((entry) => {
        const section = entry.target;
        const sectionIndex = [...sections].findIndex(
          (el) => el.id === section.id,
        );

        if (entry.isIntersecting) {
          if (section.firstElementChild?.dataset?.name) {
            const { name } = section.firstElementChild.dataset;

            sendEvent('home_content_view', {
              contentName: `${name} view`,
              contentPage: `${window.SAJE?.pageType}`,
              contentPosition: sectionIndex + 1,
            });

            observer.unobserve(entry.target);
          }
        }
      });
    }

    let observer = new IntersectionObserver(callbackFunction, options);
    mainContent.querySelectorAll('.shopify-section').forEach((section) => {
      if (section) observer.observe(section);
    });
  };

  const trackItemClick = () => {
    sections.forEach((section) => {
      section.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (e) => {
          const parent = e.target.closest('.shopify-section');
          const sectionIndex = [...sections].findIndex(
            (elem) => elem.id === parent.id,
          );
          const { name } = parent.firstElementChild.dataset;

          if (!name) return false;

          e.preventDefault();

          const contentText = e.target.innerText
            ? e.target.innerText.toLowerCase()
            : link.dataset.title?.toLowerCase();

          sendEvent('home_content_click', {
            contentName: `${name} click`,
            contentPage: `${window.SAJE?.pageType}`,
            contentPosition: sectionIndex + 1,
            contentText,
            destinationPage: link.href,
          });

          window.location.href = link.href;
          return false;
        });
      });
    });
  };

  trackItemView();
  trackItemClick();
};
// ToDo
export const trackPDPGalleryClick = (text) => {
  Shopify.analytics.publish('pdp_gallery_click', {
    text,
  });
};
// ToDo
export const trackPDPReviewClick = (position) => {
  Shopify.analytics.publish('pdp_review_click', {
    position,
  });
};

export const trackPDPToggleClick = (text) => {
  Shopify.analytics.publish('pdp_toggle_click', {
    text,
  });
};

export const trackPDPAddToBag = ({ item, itemId, quantity }) => {
  Shopify.analytics.publish('pdp_add_to_bag', {
    item,
    itemId,
    quantity,
  });
};

export const trackPDPBundleClick = (text) => {
  Shopify.analytics.publish('pdp_bundle_click', {
    text,
  });
};
// ToDo
export const trackPDPPaymentMethodClick = (text) => {
  Shopify.analytics.publish('pdp_payment_click', {
    text,
  });
};

export const trackPDPKeyIngredientClick = (text) => {
  Shopify.analytics.publish('pdp_key_ingredient_click', {
    text,
  });
};

export const trackPDPSetIncludeClick = (text) => {
  Shopify.analytics.publish('pdp_set_include_click', {
    text,
  });
};

export const trackPDPShippingClick = (text) => {
  Shopify.analytics.publish('pdp_shipping_click', {
    text,
  });
};

export const trackPDPInfoClick = ({ action, text }) => {
  Shopify.analytics.publish('pdp_info_click', {
    action,
    text,
  });
};

export const trackPLPBannerClick = (text) => {
  Shopify.analytics.publish('plp_banner_click', {
    text,
  });
};

export const trackFilterClick = (text, page) => {
  Shopify.analytics.publish('filter_click', {
    page,
    text,
  });
};

// Mini cart
export const trackMiniCartRemove = ({ item, itemId, quantity }) => {
  Shopify.analytics.publish('mini_cart_remove_click', {
    item,
    item_id: itemId,
    quantity,
  });
};

export const trackMiniCartProductClick = ({ item, itemId, text }) => {
  Shopify.analytics.publish('mini_cart_product_click', {
    item,
    item_id: itemId,
    text,
  });
};

export const trackMiniCartATBClick = ({ item, itemId }) => {
  Shopify.analytics.publish('mini_cart_ATB_click', {
    item,
    item_id: itemId,
  });
};

export const trackMiniCartATB = ({ item, itemId, quantity }) => {
  Shopify.analytics.publish('mini_cart_ATB', {
    item,
    item_id: itemId,
    quantity,
  });
};

// Quick view

export const trackQuickViewATBClick = ({
  item,
  itemId,
  size,
  quantity,
  color,
}) => {
  Shopify.analytics.publish('quick_view_ATB_click', {
    item,
    item_id: itemId,
    size,
    quantity,
    color,
  });
};

export const trackQuickViewFullPage = ({ item, itemId }) => {
  Shopify.analytics.publish('quick_view_full_page_click', {
    item,
    item_id: itemId,
  });
};

export default Tracking;
